import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const weibo: Platform = {
  id: 'weibo',
  name: '微博',
  iconIndex: PlatformRegistry.weibo.index,
  color: PlatformRegistry.weibo.color,
  buildUrl: (content: ShareContent): string => {
    // Weibo uses hashtag format in title
    const hashtags = content.hashtags?.length 
      ? `#${content.hashtags.join('# #')}# ` 
      : '';
    return buildShareUrl('https://service.weibo.com/share/share.php', {
      title: `${hashtags}${content.title || ''}`,
      url: content.url,
      pic: content.image,
    });
  },
};

